function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "graph",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M0,24a3,3,0,0,1,3-3,3.062,3.062,0,0,1,.536.054l5.2-9.108A2.983,2.983,0,0,1,11,7a3,3,0,0,1,3,3,2.965,2.965,0,0,1-.384,1.439l4.255,4.785A2.98,2.98,0,0,1,19,16a2.879,2.879,0,0,1,.363.037l5.481-10.96A2.994,2.994,0,1,1,27,6a3.056,3.056,0,0,1-.363-.037L21.156,16.923A3,3,0,1,1,16,19a2.966,2.966,0,0,1,.38-1.439l-4.255-4.784a2.851,2.851,0,0,1-1.661.169l-5.2,9.108A2.994,2.994,0,1,1,0,24Z",
  fill: "#02eb02"
}));

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.8ea70a34.svg";
export { ForwardRef as ReactComponent };